export const DEFAULT_PROFILE_IMAGE = "/assets/icons/menu/user-active.svg"
